module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.url(_vm.post) != '') ? _c('a', {
    staticClass: "postLinkContainer",
    attrs: {
      "href": _vm.url(_vm.post),
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))]), (_vm.post.acf.記載元 == '地方紙') ? _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.renderText("地方紙", "local")))]) : _vm._e(), (_vm.post.acf.記載元 == '全国紙') ? _c('p', {
    staticClass: "category nation"
  }, [_vm._v(_vm._s(_vm.renderText("全国紙", "nation")))]) : _vm._e(), _c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.decodedTitle)
    }
  })]) : _vm._e(), (_vm.url(_vm.post) == '') ? _c('div', {
    staticClass: "postLinkContainer disabled"
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))]), _c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.decodedTitle)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bcd8e1d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archive/news/postLink.vue
// module id = 102
// module chunks = 1